import { useUniversalContext } from '@cxc/react-universal-components'
import { getTransactionFromLocalStorage } from '../../utils/transactionDetails'
import { CountryCode, Currency } from '../../types/locale'
import { convertFractionalToWholeCurrency } from '../../utils/formatting'
import {
  calculateCartQuantity,
  calculateShippingAmount,
  calculateSubtotalAmount,
} from '../../utils/checkout'
import { useLocation } from 'react-router-dom'
import { Route } from '../../routes'
import { ItemizedTax } from '../../types/models'

export function useProductInfo(currency: Currency, countryCode: CountryCode) {
  const route = useLocation().pathname
  const routeIsCheckout = route.includes(Route.PaymentCheckout)

  const { getCartItems } = useUniversalContext()
  const cartItems = getCartItems()
  const transactionData = getTransactionFromLocalStorage()

  const cartQuantity = calculateCartQuantity(cartItems)

  let subtotal = convertFractionalToWholeCurrency(
    calculateSubtotalAmount(cartItems, currency),
  )
  let shipping = calculateShippingAmount(cartItems, countryCode)

  let total = subtotal + shipping

  let totalTax: number | undefined = undefined

  let retailDeliveryFee = 0

  let itemizedTaxes: ItemizedTax[] = []

  if (routeIsCheckout && transactionData !== undefined) {
    subtotal = transactionData.subTotal
    shipping = transactionData.shippingCost
    totalTax = transactionData.totalTax
    total = transactionData.orderTotal
    retailDeliveryFee = transactionData.retailDeliveryFee
    if (transactionData.itemizedTaxes) {
      itemizedTaxes = transactionData.itemizedTaxes
    }
  }

  return {
    cartQuantity,
    total,
    shipping,
    totalTax,
    subtotal,
    routeIsCheckout,
    retailDeliveryFee,
    itemizedTaxes,
  }
}
